<template>
    <div class="box">
        <div class="box-header box-clearfix">
            <div class="box-title">
                <a href="javascript:;">Withdrawal</a>
            </div>
        </div>
        <div class="box-body">
            <div class="withdraw-view">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="withdraw-ruleForm">

                    <el-form-item label="The Trading Account :" prop="mt4_id">
                        <el-select v-model="ruleForm.mt4_id" placeholder="Please Select" style="width:100%"
                                   @change="change_current_mt4_id">
                            <el-option :label="val.mt4_id" :value="val.mt4_id" v-for="(val,key) in mt4Arr">
                                {{val.mt4_id}}
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Bank Account used previously :" class="Bank-Account-previously">
                        <el-select v-model="ruleForm.bank_id" placeholder="Please Select" style="width:100%"
                                   @change="change_bank_id">
                            <el-option
                                    label="Please provide your bank account details or use a bank account you have previously saved in MyZFX."
                                    value="default"></el-option>
                            <el-option :label="val.bank_name" :value="val.id" v-for="(val,key) in bankList">
                                {{val.bank_name}}
                            </el-option>
                            <el-option label="Provide Add A New Profile" value="add"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Withdrawal Type :" prop="withdrawal_type">
                        <el-select :disabled="withdraw_rules" v-model="ruleForm.withdrawal_type"
                                   placeholder="Please Select" style="width:100%" @change="change_withdrawal_type">
                            <el-option label="Transfer to UK Bank Account" value="1"></el-option>
                            <el-option label="International Bank Transfer " value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Benefiary :">
                        {{this.$store.state.user_info.full_name}}
                    </el-form-item>

                    <el-form-item label="Bank name :" prop="bank_name">
                        <el-input v-model="ruleForm.bank_name" :disabled="withdraw_rules"></el-input>
                    </el-form-item>

                    <el-form-item label="Bank Address :" prop="bank_addr">
                        <el-input v-model="ruleForm.bank_addr" :disabled="withdraw_rules"></el-input>
                    </el-form-item>

                    <el-form-item label="Sort code :" prop="sort_code" v-if="ruleForm.withdrawal_type==='1'">
                        <el-input v-model="ruleForm.sort_code" :disabled="withdraw_rules"></el-input>
                    </el-form-item>

                    <el-form-item label="Account number :" prop="account_number">
                        <el-input v-model="ruleForm.account_number" :disabled="withdraw_rules"></el-input>
                    </el-form-item>

                    <el-form-item label="BIC / SWIFT:" prop="swift">
                        <el-input v-model="ruleForm.swift" :disabled="withdraw_rules"></el-input>
                    </el-form-item>

                    <el-form-item label="IBAN :">
                        <el-input v-model="ruleForm.iban" :disabled="withdraw_rules" placeholder="optional"></el-input>
                    </el-form-item>

                    <el-form-item class="amount-view" label="Amount :" prop="amount">
                        <el-input
                                v-model.trim="ruleForm.amount"
                                @on-keyup="ruleForm.amount=ruleForm.amount.replace(/[^\d.]/g, '')"
                        ></el-input>
                        <span class="amount-type">{{current_mt4_id.currency_type_text}}</span>
                    </el-form-item>
                    <el-form-item label="Withdrawal Fees :">
                        <em class="bidge">{{fee}}</em> {{current_mt4_id.currency_type_text}}
                    </el-form-item>

                    <el-form-item label="Net Amount :">
                        <em class="bidge">{{ruleForm.amount?(ruleForm.amount - fee).toFixed(2):0}}</em>
                        {{current_mt4_id.currency_type_text}}
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')" class="box-btn"
                                   :loading="btn_loading_w" style="width: 300px;">Submit
                        </el-button>
                    </el-form-item>
                </el-form>

                <dl class="foot-tips">
                    <dt>Notes:</dt>
                    <dd>Free of charge when you withdraw funds to UK bank accounts.</dd>
                    <dd>Free of charge when you withdraw funds using China UnionPay.</dd>
                    <dd>Withdraw via international bank transfer: Free to withdraw twice per calendar month, or 15 USD
                        (or equivelent) per transaction thereafter to cover the bank costs incurred to us.
                        (Please note that your own bank may also charge you additional fees.)
                    </dd>
                    <dd>We cannot send funds to a bank account held by a third party beneficairy other than the Trading
                        Account Holder.
                    </dd>
                    <dd>If you have any open trades, please ensure you still have enough funds to cover your required
                        margin after you have transferred or withdrawn funds out of your trading account, so that they
                        are not affected.
                        We cannot be held liable for your trades being closed out due to insufficient margin level on
                        your trading account.
                    </dd>
                </dl>
            </div>
        </div>

        <el-dialog
                :visible.sync="withdraw_dialog_visible"
                width="520px"
                :before-close="handleClose"
                class="withdraw-dialog"
        >
            <h3 class="title">Profile Settings</h3>
            <el-form :model="ruleForm_dialog" :rules="rules_dialog" ref="ruleForm_dialog" label-width="150px"
                     class="Withdraw-ruleForm">
                <el-form-item label="Withdrawal Type :" prop="withdrawal_type">
                    <el-select v-model="ruleForm_dialog.withdrawal_type" placeholder="Please Select"
                               @change="change_dialog_withdrawal_type" style="width:100%">
                        <el-option label="Transfer to UK Bank Account" value="1"></el-option>
                        <el-option label="International Bank Transfer " value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Beneficiary :" prop="confirm_password">
                    {{this.$store.state.user_info.full_name}}
                </el-form-item>
                <el-form-item label="Bank name :" prop="bank_name">
                    <el-input v-model="ruleForm_dialog.bank_name"></el-input>
                </el-form-item>
                <el-form-item label="Bank Address :" prop="bank_addr">
                    <el-input v-model="ruleForm_dialog.bank_addr"></el-input>
                </el-form-item>
                <el-form-item label="SORT CODE :" prop="sort_code" v-if="ruleForm_dialog.withdrawal_type==='1'">
                    <el-input v-model="ruleForm_dialog.sort_code"></el-input>
                </el-form-item>
                <el-form-item label="Account number :" prop="account_number">
                    <el-input v-model="ruleForm_dialog.account_number"></el-input>
                </el-form-item>
                <el-form-item label="BIC / SWIFT:" prop="swift">
                    <el-input v-model="ruleForm_dialog.swift"></el-input>
                </el-form-item>
                <el-form-item label="IBAN :">
                    <el-input v-model="ruleForm_dialog.iban" placeholder="optional"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="box-btn" style="width:200px;" :loading="btn_loading"
                               @click="submitForm_dialog('ruleForm_dialog')">Submit
                    </el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">  </span>
        </el-dialog>

    </div>
</template>

<script>
import * as server from './action'

export default {
  data () {
    let msgboxOption = {
      dangerouslyUseHTMLString: true,
      center: true,
      customClass: 'withdraw-view-msgbox',
      showClose: false
    }
    var checkAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Can not be empty'))
      }

      if (!Number(value)) {
        callback(new Error('Please enter a numeric value'))
      } else {
        console.log('value.length', value)
        if (value.toString().length > 8) {
          callback(new Error('8-digit input limit'))
        } else {
          callback()
        }
      }
    }

    var checkAmount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Can not be empty'))
      }
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('Amount up to 2 decimal places'))
      } else if (Number(value) === 0) {
        callback(new Error('The amount cannot be 0'))
      } else {
        callback()
      }
    }
    return {
      withdraw_dialog_visible: false,
      mt4Arr: [],
      bankList: [],
      current_mt4_id: {},
      current_bank: {},
      fee: '',
      ruleForm: {
        mt4_id: '',
        bank_id: '',
        withdrawal_type: '1',
        bank_name: '',
        bank_addr: '',
        sort_code: '',
        swift: '',
        iban: '',
        account_number: '',
        amount: ''
      },
      withdraw_rules: false,
      rules: {
        mt4_id: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        bank_id: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        withdrawal_type: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        bank_name: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        bank_addr: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        sort_code: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        account_number: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        amount: [{ required: true, validator: checkAmount, trigger: 'blur' }],
        swift: [{ required: true, message: 'Please Enter', trigger: 'change' }]
      },
      ruleForm_dialog: {
        withdrawal_type: '1',
        bank_name: '',
        bank_addr: '',
        sort_code: '',
        account_number: '',
        swift: '',
        iban: ''
      },
      rules_dialog: {
        withdrawal_type: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        bank_name: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        bank_addr: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        sort_code: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        account_number: [
          { required: true, validator: checkAccount, trigger: 'blur' }
        ],
        swift: [{ required: true, message: 'Please Enter', trigger: 'change' }]
      },
      btn_loading: false,
      btn_loading_w: false,
      msgboxSuccess: {
        ...msgboxOption,
        iconClass: 'ico-box ico-success',
        confirmButtonText: 'Continue'
      },
      msgboxSuccessTxt: 'Transfer successful.',
      msgboxWarning: {
        ...msgboxOption,
        iconClass: 'ico-box ico-warning',
        confirmButtonText: 'OK'
      },
      msgboxWarningTxt:
          'It appears that you have open trade(s) in your trading<br/>  account, and the amount you are withdrawing/transferring<br/> out of it has exceeded the minimum required <br/>  margin level in order to sustain the trade(s).<br/> Please try again after you have closed your position(s).',

      msgboxFailed: {
        ...msgboxOption,
        iconClass: 'ico-box ico-failed',
        confirmButtonText: 'OK'
      },
      msgboxFailedTxt:
          'Transfer failed.<br/> Insufficient balance in your originating tradi'
    }
  },
  beforeRouteEnter (to, from, next) {
    server
      .get_withdrawal()
      .then(data => {
        next(vm => vm.setinfo(data))
      })
      .catch(() => {
        next()
      })
  },
  created () {
    // this.$alert(this.msgboxFailedTxt, this.msgboxFailed)
  },
  methods: {
    setinfo (val) {
      this.mt4Arr = val.mt4Arr
      this.bankList = val.bankList
      this.ruleForm.mt4_id = val.mt4Arr[0].mt4_id || ''
      console.log(this.$route.params)
      if (this.$route.params.mt4_id) {
        this.change_current_mt4_id(this.$route.params.mt4_id)
        this.ruleForm.mt4_id = this.$route.params.mt4_id
      } else {
        console.log('88888888', this.mt4Arr[0])
        this.current_mt4_id = this.mt4Arr[0] || {}
      }
      this.fee_tap()
    },
    submitForm (formName) {
      this.btn_loading_w = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit_withdrawal()
        } else {
          this.btn_loading_w = false
          console.log('error submit!!')
          return false
        }
      })
    },
    change_bank_id (val) {
      if (val === 'add') {
        this.btn_loading = false
        this.withdraw_dialog_visible = true
        this.ruleForm_dialog.iban = ''
      } else if (val === 'default') {
        this.reset_form()
      } else {
        this.withdraw_rules = true
        const { bankList = [] } = this
        bankList.map((item, key) => {
          if (val === item.id) {
            this.current_bank = item
          }
        })
        console.log('this.current_bank', this.current_bank)
        console.log(this.current_bank.swift_code, this.current_bank.branch_info)
        this.ruleForm.bank_name = this.current_bank.bank_name
        this.ruleForm.bank_addr = this.current_bank.bank_addr
        this.ruleForm.withdrawal_type = this.current_bank.bank_type
        this.ruleForm.sort_code = this.current_bank.sort_code
        this.ruleForm.swift = this.current_bank.swift_code
        this.ruleForm.account_number = this.current_bank.account_number
        this.ruleForm.iban = this.current_bank.iban
        this.fee_tap()
        /* 根据银行切换费率 */
      }
    },
    reset_form () {
      this.withdraw_rules = false
      this.ruleForm.bank_name = ''
      this.ruleForm.bank_addr = ''
      this.ruleForm.withdrawal_type = '1'
      this.ruleForm.sort_code = ''
      this.ruleForm.swift = ''
      this.ruleForm.account_number = ''
      this.ruleForm.iban = ''
    },
    handleClose (done) {
      this.ruleForm.bank_id = ''
      done()
    },
    change_current_mt4_id (value) {
      const { mt4Arr = [] } = this
      mt4Arr.map((item, key) => {
        const { mt4_id } = item
        if (value === item.mt4_id) {
          this.current_mt4_id = item
        }
      })
      this.fee_tap()
    },
    fee_tap () {
      if (Number(this.ruleForm.withdrawal_type) === 1) {
        this.fee = 0
      } else {
        this.fee = this.current_mt4_id.fee
      }
    },
    change_withdrawal_type (val) {
      /* 切换时重置数据 */
      this.fee_tap()
      this.ruleForm.sort_code = ' '
    },
    change_dialog_withdrawal_type (val) {
      /* 切换时重置弹窗中数据 */
      this.ruleForm_dialog.sort_code = ' '
    },
    submitForm_dialog (formName) {
      this.btn_loading = true

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.add_bank_info()
        } else {
          this.btn_loading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submit_withdrawal () {
      console.log('that.current_mt4_id', this.current_mt4_id)
      console.log('that.current_bank', this.current_bank)

      /* if (Number(this.ruleForm.withdrawal_type) === 2) {
          if (!this.ruleForm.iban) {
            this.$message({
              message: 'Please enter IBAN',
              type: 'warning'
            })
            this.btn_loading_w = false
            return false
          }
        } */

      if (Number(this.ruleForm.amount) <= 0) {
        this.btn_loading_w = false
        this.$message({
          message: 'Please enter an amount greater than 0',
          type: 'warning'
        })
        return false
      }
      this.fee_tap()
      /* 根据银行切换费率 */

      if (this.ruleForm.bank_id === 'default') {
        this.ruleForm.bank_id = ''
      }
      // add_bank_info
      let params = {
        bank_type: this.ruleForm.withdrawal_type,
        mt4_id: this.ruleForm.mt4_id,
        currency_type: this.current_mt4_id.currency_type,
        bank_list_id: this.ruleForm.bank_id,
        fee: this.fee,
        bank_name: this.ruleForm.bank_name,
        bank_addr: this.ruleForm.bank_addr,
        current_money: this.ruleForm.amount,
        actual_amount: this.ruleForm.amount - this.fee,
        account_number: Number(this.ruleForm.account_number),
        sort_code: this.ruleForm.sort_code,
        swift_code: this.ruleForm.swift,
        iban: this.ruleForm.iban
      }
      server
        .submit_withdrawal(params, true)
        .then(res => {
          this.btn_loading_w = false
          /* this.withdraw_dialog_visible = false */
          if (res.code === 200) {
            this.$alert(
              `Application is successful.<br/>
            We aim to complete the verification of your application<br/>
            within 1 working day and will inform you of the outcome<br/>
            as soon as possible.`,
              this.msgboxSuccess
            ).then(() => {
              this.$router.push({ name: 'WithdrawRecord' })
            })
          } else if (res.code === 400) {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          } else if (res.code === 500) {
            this.$alert(
              `Withdrawal failed.<br/>
             ${res.message}`,
              this.msgboxFailed
            ).then(() => {})
          } else if (res.code === 501) {
            this.$alert(`${res.message}`, this.msgboxWarning).then(() => {})
          } else {
            this.$alert(`${res.message}`, this.msgboxWarning).then(() => {})
          }
        })
        .catch(err => {
          this.btn_loading_w = false
        })
    },
    add_bank_info () {
      /* if (Number(this.ruleForm_dialog.withdrawal_type) === 2) {
           if (!this.ruleForm_dialog.iban) {
             this.$message({
               message: 'Please enter IBAN',
               type: 'warning'
             })
             this.btn_loading = false
             return false
           }
         } */

      // add_bank_info
      let params = {
        bank_type: this.ruleForm_dialog.withdrawal_type,
        account_number: this.ruleForm_dialog.account_number,
        bank_name: this.ruleForm_dialog.bank_name,
        bank_addr: this.ruleForm_dialog.bank_addr,
        sort_code: this.ruleForm_dialog.sort_code,
        swift_code: this.ruleForm_dialog.swift,
        iban: this.ruleForm_dialog.iban
      }
      server.add_bank_info(params, true).then(res => {
        if (res.code === 200) {
          this.$alert(
            'Add a new profile successfully.',
            this.msgboxSuccess
          ).then(() => {
            this.btn_loading = false
            this.$refs['ruleForm_dialog'].resetFields()
            this.withdraw_dialog_visible = false
            this.ruleForm.bank_id = ''
            server
              .get_withdrawal()
              .then(res => {
                this.reset_form()
                this.bankList = res.bankList
              })
              .catch(() => {})
          })
        } else {
          this.btn_loading = false
          this.$message({
            message: res.message,
            type: 'warning'
          })
        }
        /* this.withdraw_dialog_visible = false */
        /* Add a new profile successfully. */
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .withdraw-view {
        .Bank-Account-previously {
            .el-form-item__label {
                line-height: 20px;
            }
        }
        .withdraw-ruleForm {
            width: 480px;
            margin: 40px auto 0;
            .el-form-item__label {
                text-align: left;
            }
            .bidge {
                color: #0A95FF;
            }
        }
        &-msgbox {
            &.el-message-box--center {
                width: 520px;
                padding: 30px 0 60px 0;
            }
            .ico-box {
                width: 60px;
                height: 60px;
                &.ico-success {
                    background: url('~assets/img/ico-successful.png');
                }
                &.ico-failed {
                    background: url('~assets/img/ico-failed.png');
                }
                &.ico-warning {
                    background: url('~assets/img/ico-warning.png');
                }
            }

            button.el-button--primary {
                width: 253px;
                height: 42px;
                margin-top: 10px;
                background: #0A95FF;
                border-radius: 4px;
                font-size: 16px;
                color: #fff;
                &:focus,
                &:hover {
                    color: #fff;
                    opacity: 0.9;
                }
            }
        }
    }

    .amount-view {
        position: relative;
        .amount-type {
            position: absolute;
            right: -35px;
        }
    }

    .foot-tips {
        dt {
            margin-bottom: 10px;
            color: #666666;
        }
        dd {
            position: relative;
            padding-left: 10px;
            font-size: 14px;
            font-weight: normal;
            letter-spacing: 0.8px;
            color: #666666;
            &:before {
                content: '*';
                color: #0A95FF;
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                font-size: 12px;
                line-height: 24px;
            }
        }
    }

    .withdraw-dialog {
        .title {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 19px;
            letter-spacing: 0px;
            color: #333333;
            padding-left: 40px;
        }
        .Withdraw-ruleForm {
            width: 400px;
            margin: 30px auto 0;
            .el-form-item__label {
                text-align: left;
            }
        }
    }
</style>
